export default __webpack_public_path__ + "static/media/b3.b8337aa1.jpg";